import { render, staticRenderFns } from "./NewsletterCreate.vue?vue&type=template&id=221a2acd&"
import script from "./NewsletterCreate.vue?vue&type=script&lang=js&"
export * from "./NewsletterCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports